import { type ReactElement, useContext, useEffect, useId } from "react";

import { HallidayContext } from "./context";

/**
 * Inline EMBED mount point. Renders a `<div>` and registers its id with the Provider's instance, so
 * the widget mounts in place instead of as a MODAL overlay.
 *
 * The child effect runs before the Provider's warm effect, so the target is registered before warming →
 * the iframe is born in EMBED mode with no MODAL→EMBED reload. Singleton per Provider (a second
 * `<HallidayEmbed>` is dev-warned and ignored); unmounting returns the instance to MODAL.
 */
export const HallidayEmbed = (): ReactElement => {
    const ctx = useContext(HallidayContext);
    const id = useId();
    useEffect(() => ctx?.embed(id), [ctx, id]);

    if (!ctx) {
        throw new Error("<HallidayEmbed> must be rendered inside a <HallidayPaymentsProvider>.");
    }
    return <div id={id} />;
};
